import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { DataService } from '../port/data.service';
import { AuthenticationService } from '@app/core/port/authentication.service';
import { environment } from '@env/environment';

@Injectable()
export class DataLocalhostService implements DataService {
  private readonly baseUrl = 'http://localhost:3000';

  constructor(
    private readonly http: HttpClient,
    private readonly authenticationService: AuthenticationService
  ) {}
  get<T>(endpoint: string): Observable<T> {
    const url = `${this.baseUrl}/${endpoint}`;
    if (!environment.production) {
      console.log('📡 GET:', url);
    }
    
    return this.http.get<T>(url, { headers: this.getAuthHeaders() }).pipe(
      tap({
        next: data => {
          if (!environment.production) {
            console.log('✅ GET Success:', data);
          }
        },
        error: error => console.error('❌ GET Error:', error)
      })
    );
  }
  patch<T, P = any>(endpoint: string, payload: P): Observable<T> {
    const url = `${this.baseUrl}/${endpoint}`;
    if (!environment.production) {
      console.log('📡 PATCH:', url);
      console.log('📦 Payload:', payload);
    }
    
    return this.http.patch<T>(url, payload, { headers: this.getAuthHeaders() }).pipe(
      tap({
        next: data => {
          if (!environment.production) {
            console.log('✅ PATCH Success:', data);
          }
        },
        error: error => console.error('❌ PATCH Error:', error)
      })
    );
  }

  private getAuthHeaders(): HttpHeaders {
    const token = this.authenticationService.getToken();
    if (!environment.production) {
      console.log('🔐 Token présent:', !!token);
    }
    return token 
      ? new HttpHeaders({ 
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }) 
      : new HttpHeaders({ 'Content-Type': 'application/json' });
  }

  fetch<T>(endpoint: string): Observable<T> {
    const url = `${this.baseUrl}/${endpoint}`;
    if (!environment.production) {
      console.log('📡 GET:', url);
    }
    
    return this.http.get<T>(url, { headers: this.getAuthHeaders() }).pipe(
      tap({
        next: data => {
          if (!environment.production) {
            console.log('✅ GET Success:', data);
          }
        },
        error: error => console.error('❌ GET Error:', error)
      })
    );
  }

  put<T, P = any>(endpoint: string, payload: P): Observable<T> {
    const url = `${this.baseUrl}/${endpoint}`;
    if (!environment.production) {
      console.log('📡 PUT:', url);
      console.log('📦 Payload:', payload);
    }
    
    return this.http.put<T>(url, payload, { headers: this.getAuthHeaders() }).pipe(
      tap({
        next: data => {
          if (!environment.production) {
            console.log('✅ PUT Success:', data);
          }
        },
        error: error => console.error('❌ PUT Error:', error)
      })
    );
  }

  // Les autres méthodes restent identiques mais avec des logs similaires
  create<T>(endpoint: string, payload: T): Observable<void> {
    const url = `${this.baseUrl}/${endpoint}`;
    if (!environment.production) {
      console.log('📡 POST:', url);
    }
    return this.http.post<void>(url, payload, { headers: this.getAuthHeaders() });
  }

  update<T>(endpoint: string, payload: T): Observable<void> {
    return this.put<void, T>(endpoint, payload);
  }

  post<T, P = any>(endpoint: string, payload: P): Observable<T> {
    const url = `${this.baseUrl}/${endpoint}`;
    if (!environment.production) {
      console.log('📡 POST:', url);
    }
    return this.http.post<T>(url, payload, { headers: this.getAuthHeaders() });
  }

  delete<T = void>(endpoint: string): Observable<T> {
    const url = `${this.baseUrl}/${endpoint}`;
    if (!environment.production) {
      console.log('📡 DELETE:', url);
    }
    return this.http.delete<T>(url, { headers: this.getAuthHeaders() });
  }
}